<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oaQgnt/tc-custom/9781497681996.jpg?1702844345416" alt="This image is the cover for the book Just Between Us"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Just Between Us
      </h1>
      <p class="bookDescription body article font2">
        <b>An incurable gossip tries to learn how to keep secrets to herself</b><br/><br/> Sometimes Cass just can’t help herself. Tell her something personal, even something embarrassing, and before you know it, the whole school will have heard. It’s not that Cass doesn’t want to keep secrets—she just doesn’t know how. After her bad habit lands her in a fight with one of her friends, Cass asks her family for help. Mom proposes a psychological experiment. Every time Cass manages to keep a secret, she’ll get a dollar—and a lesson worth far more than that.<br/>  <br/> It’s easy at first, but pretty soon Cass is so full of gossip, she feels like she’s going to burst. When an earth-shattering secret traps her in the middle of her two best friends, she learns that sometimes it’s more important not to keep your mouth shut.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Beth Pfeffer
      </h2>
      
      <p class="authorDescription body article">Susan Beth Pfeffer wrote her first novel,&#160;<I>Just Morgan</I>, during her last semester at New York University. Since then, she has written over seventy novels for children and young adults, including&#160;<I>Kid Power</I>,&#160;<I>Fantasy Summer</I>, <I>Starring Peter and Leigh</I>, and&#160;<I>The Friendship Pact</I>, as well as the series Sebastian Sisters and Make Me a Star. Pfeffer&rsquo;s books have won ten statewide young reader awards and the Buxtehude Bulle Award.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b29d52c